const MOBILE_VIEWPORT = 767;

export default {
    data() {
        return {
            screenWidth: window.innerWidth,
        };
    },

    computed: {
        isDesktopOrTablet() {
            return this.screenWidth > MOBILE_VIEWPORT;
        },

        isMobile() {
            return this.screenWidth <= MOBILE_VIEWPORT;
        },
    },

    methods: {
        windowUpdateWidth() {
            this.screenWidth = window.innerWidth;
        },
    },

    mounted() {
        window.addEventListener('resize', this.windowUpdateWidth);
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.windowUpdateWidth);
    },
};